angular.module('zc.projects')

.directive 'pageTypeSelector', ($modal, $translate, Image, lib) ->
  restrict: 'E'
  scope:
    pageTypes: '='
    item: '='
    disabled: '='
  template: """
    <select
      class="multi-select"
      style="width: 100%"
      ng-model="pageTypes"
      name="{{ scope.item.name }}"
      ng-required="scope.item.required"
      multiple="true"
    ></select>
  """
  link: (scope, element, attrs) ->
    element = element.children('select')
    if scope.disabled in ['true', true]
      pageTypes = scope.pageTypes
      element.prop('disabled', true)
    else
      pageTypes = scope.$parent.$parent.$parent.pageTypes

      # When editing a campaign, filter out no longer existing page types from the model
      scope.pageTypes = _.filter(
        scope.pageTypes,
        (pageType) ->
          _.includes(pageTypes, pageType)
      )

    data = _.map pageTypes, (pageType) -> {
      id: pageType,
      text: pageType,
      selected: _.includes(scope.pageTypes, pageType)
    }

    element.select2({
      data: data,
      placeholder: $translate.instant scope.item.placeholder,
    })



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/page_type_selector.coffee